module.exports = __webpack_public_path__ + "img/futurad.c1f5b397.png";